<template>
  <g>
    <polyline :points="points" />
    <svg-badge :x="lx" :y="ly" variant="primary" :scale="scale">${{ annotation.label }}</svg-badge>
  </g>
</template>

<script>
  import { AnnotationResource } from '@/api-resources';
  import SvgBadge from './SvgBadge';

  export default {
    name: 'AnnotationPolyline',

    components: {
      SvgBadge,
    },

    props: {
      annotation: AnnotationResource,
      scale: Number,
    },

    computed: {
      coordinates() {
        const coordinates = [];

        for (let i = 0; i < this.annotation.coordinates.length; i = i + 2) {
          const x = this.annotation.coordinates[i] + this.annotation.originRow;
          const y = this.annotation.coordinates[i + 1] + this.annotation.originColumn;

          coordinates.push([x, y]);
        }

        return coordinates;
      },

      points() {
        return this.coordinates.map((points) => points.join(',')).join(' ');
      },

      lowest() {
        return this.coordinates.reduce((lowest, point) => (point[1] > lowest[1] ? point : lowest));
      },

      lx() {
        return this.lowest[0] - 30;
      },

      ly() {
        return this.lowest[1] + 10;
      },
    },
  };
</script>

<style scoped></style>
